<template>
  <div>
    <div
      class="d-flex flex-row align-items-center settings-header sticky-top justify-content-between"
    >
      <div class="d-flex flex-row align-items-center">
        <div class="settings-header-icon-wrapper mr-2">
          <font-awesome-icon
            class="settings-header-icon"
            :icon="['fas', 'cog']"
          />
        </div>
        <el-divider direction="vertical" class="menu-divider mr-3"></el-divider>
        <span class="uppercase">{{ $t('settings.title') }}</span>
      </div>
    </div>
    <div class="settings-container">
      <SettingsMenu :data="menuData" class="settings-menu" />

      <router-view
        class="settings-view"
        :items="menuData"
        :success="success"
      ></router-view>
    </div>
  </div>
</template>
<script>
import SettingsMenu from 'components/Settings/SettingsMenu';
import { mapGetters, mapActions } from 'vuex';

export default {
  name: 'SettingsLayout',
  components: {
    SettingsMenu,
  },
  async created() {
    this.success = await this.getCompanyDetails();
  },
  data() {
    return {
      success: true,
      menuData: [
        {
          title: 'settings-layout.menu-data.general',
          icon: ['fad', 'sliders-v'],
          children: [
            {
              title: 'settings-layout.menu-data.kb-manage',
              name: 'generalSettings',
              hash: '#knowledges',
              icon: ['fas', 'folder'],
              component: 'KnowledgeManageSettings',
            },
            {
              title: 'settings-layout.menu-data.alerts-notifications',
              name: 'generalSettings',
              hash: '#alerts',
              icon: ['fas', 'bell'],
              component: 'AlertsSettings',
            },
          ],
        },
        {
          title: 'settings-layout.menu-data.integrations',
          icon: ['fad', 'layer-group'],
          children: [
            {
              title: 'settings-layout.menu-data.integration-list',
              name: 'integrationSettings',
              hash: '#catalog',
              icon: ['fas', 'chart-network'],
              component: 'IntegrationSettingsPage',
            },
          ],
        },
        {
          title: 'settings-layout.menu-data.plugins.title',
          icon: ['fad', 'puzzle-piece'],
          children: [
            {
              title: 'settings-layout.menu-data.plugins.plugins-catalog',
              name: 'pluginsCatalog',
              hash: '#plugin-catalog',
              component: 'PluginCatalog',
              icon: ['fad', 'plug'],
              props: {
                children: [
                  {
                    title:
                      'settings-layout.menu-data.plugins.company-favorites',
                    name: 'pluginsSetting',
                    hash: '#company-favorites',

                    component: 'PluginSetting',
                    props: {
                      label:
                        'settings-layout.menu-data.plugins.company-favorites.title',
                      description:
                        'settings-layout.menu-data.plugins.company-favorites.description',
                      activeText:
                        'settings-layout.menu-data.plugins.company-favorites.active-text',
                      disableText:
                        'settings-layout.menu-data.plugins.company-favorites.disable-text',
                      companyPreference: 'ALLOW_COMPANY_FAVORITES',
                      getter: 'companyAllowCompanyFavoritesPreference',
                    },
                  },
                ],
              },
            },
          ],
        },
        {
          title: 'settings-layout.menu-data.permissions',
          icon: ['fad', 'unlock'],
          children: [
            {
              title: 'settings-layout.menu-data.users',
              name: 'usersSettings',
              hash: `#users`,
              icon: ['fas', 'users'],
              component: 'UsersSettings',
            },
            {
              title: 'settings-layout.menu-data.invitations',
              name: 'usersSettings',
              hash: `#pending-users`,
              icon: ['fas', 'paper-plane'],
              component: 'UsersSettings',
              props: {
                pending: true,
              },
            },
            {
              title: 'settings-layout.menu-data.groups',
              name: 'permissionsSettings',
              hash: `#groups`,
              icon: ['fas', 'user-friends'],
              component: 'GroupsSettingsMain',
            },
            {
              title: 'settings-layout.menu-data.roles',
              name: 'permissionsSettings',
              hash: `#roles`,
              icon: ['fas', 'medal'],
              component: 'RolesSettingsMain',
            },
            {
              title: 'settings-layout.menu-data.labels',
              name: 'permissionsSettings',
              hash: `#labels`,
              icon: ['fas', 'tags'],
              component: 'LabelCategorySettings',
            },
          ],
        },
        {
          title: 'settings-layout.menu-data.search',
          children: [
            {
              title: 'settings-layout.menu-data.synonyms',
              name: 'searchSettings',
              hash: '#search-settings',
              icon: ['fas', 'search'],
              component: 'SearchSettings',
              props: {
                children: [
                  {
                    title: 'settings-layout.menu-data.synonyms',
                    name: 'searchSettings',
                    icon: ['fas', 'search'],
                    component: 'SynonymsSettingsCard',
                  },
                  {
                    title: 'settings-layout.menu-data.exclusive-search.title',
                    name: 'searchSettings',
                    hash: '#exclusive-search',
                    icon: ['fas', 'union'],
                    component: 'SearchLogicSelect',
                    props: {
                      label: 'settings-layout.menu-data.exclusive-search.title',
                      description:
                        'settings-layout.menu-data.exclusive-search.description',
                      options: [
                        {
                          value: 'OR',
                          label:
                            'settings-layout.menu-data.exclusive-search.or',
                          description:
                            'settings-layout.menu-data.exclusive-search.or-description',
                          subDescription:
                            'settings-layout.menu-data.exclusive-search.or-sub-description',
                        },
                        {
                          value: 'AND',
                          label:
                            'settings-layout.menu-data.exclusive-search.and',
                          description:
                            'settings-layout.menu-data.exclusive-search.and-description',
                          subDescription:
                            'settings-layout.menu-data.exclusive-search.and-sub-description',
                        },
                      ],
                      placeholder:
                        'settings-layout.menu-data.exclusive-search.placeholder',
                      companyPreference: 'SEARCH_CATEGORIES_AND_FILTER',
                      getter: 'companyApplyExclusiveSearchPreference',
                    },
                  },
                ],
              },
            },
          ],
        },
        {
          title: 'settings-layout.menu-data.parametric-knowledge',
          icon: ['fad', 'project-diagram'],
          children: [
            ...(this.isParametric
              ? [
                  {
                    title: 'settings-layout.menu-data.global-parameters',
                    name: 'knowledgesSettings',
                    hash: '#global',
                    icon: ['fas', 'server'],
                    component: 'GlobalParameters',
                  },
                ]
              : []),
            {
              title: 'settings-layout.menu-data.content-parameters',
              name: 'knowledgesSettings',
              hash: '#contents',
              icon: ['fas', 'tags'],
              component: 'ContentParameters',
            },
          ],
        },
        {
          title: 'settings-layout.menu-data.mayday-account',
          icon: ['fad', 'cog'],
          children: [
            {
              title: 'settings-layout.menu-data.general-settings',
              name: 'companySettings',
              hash: '#company',
              icon: ['fas', 'cogs'],
              component: 'CompanySettings',
            },
          ],
        },
      ],
    };
  },
  computed: {
    ...mapGetters([
      'processedCompanyLanguages',
      'isParametric',
      'companyAllowCompanyFavoritesPreference',
      'companyAllowToastSoundPreference',
    ]),
  },
  methods: {
    ...mapActions('adminModule', ['getCompanyDetails']),
  },
};
</script>

<style lang="scss" scoped>
.settings-header {
  background-color: white;
  padding: 15px;
  border-bottom: 2px solid $grey-4-mayday;
  max-width: 100%;
  min-width: calc(100% - 60px);
  max-height: 60px;
  position: fixed;
  z-index: 10 !important;
}

.settings-menu {
  width: 20%;
  margin-left: 60px;
}

.settings-header-icon-wrapper {
  width: 32px;
  height: 32px;
  background-color: rgba($blue-mayday, 0.1);
  border-radius: 4px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.settings-header-icon {
  width: 14px;
  height: 16px;
  color: $blue-mayday;
  font-size: 16px;
}

.settings-container {
  position: relative;
}

.settings-view {
  top: 96px;
  position: absolute;
  left: 25%;
  width: 50%;
}

.uppercase {
  text-transform: uppercase;
}
</style>
